/* Wrought free-shipping goal: a thin ember bar at the top of the cart drawer and cart page.
   The threshold must match the automatic discount "Free shipping over $100" (US orders). */
(function () {
  var GOAL = 10000; // cents
  var total = null, busy = false;
  var WHY_KEY = 'Why this piece', why = null, saveT;

  var CSS =
    '.wr-goal { margin: 0 0 14px; padding: 12px 0 14px; border-bottom: 1px solid rgba(127,127,127,.18); }' +
    '#cart-drawer .wr-goal { margin-left: 20px; margin-right: 20px; }' +
    '.wr-goal__text { margin: 0 0 9px; font-size: 12px; letter-spacing: .08em; }' +
    '.wr-goal__text strong { color: #e0703a; font-weight: 600; }' +
    '.wr-goal__track { position: relative; height: 3px; background: rgba(127,127,127,.2); overflow: hidden; }' +
    '.wr-goal__fill { position: absolute; left: 0; top: 0; bottom: 0; width: 0; background: linear-gradient(90deg, #a4461f, #e0703a, #f0a36b); box-shadow: 0 0 8px rgba(224,112,58,.7); transition: width .8s cubic-bezier(.2,.7,.1,1); }' +
    '.wr-goal.is-done .wr-goal__fill::after { content: ""; position: absolute; inset: 0; background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent); animation: wr-goal-shine 2.4s ease-in-out infinite; }' +
    '@keyframes wr-goal-shine { from { transform: translateX(-100%); } to { transform: translateX(100%); } }' +
    '@media (prefers-reduced-motion: reduce) { .wr-goal__fill { transition: none; } .wr-goal.is-done .wr-goal__fill::after { animation: none; } }';

  function money(c) { return '$' + (c / 100).toFixed(c % 100 ? 2 : 0); }

  function build() {
    var el = document.createElement('div');
    el.className = 'wr-goal';
    el.setAttribute('role', 'status');
    el.innerHTML = '<p class="wr-goal__text"></p><div class="wr-goal__track" aria-hidden="true"><div class="wr-goal__fill"></div></div>';
    return el;
  }

  function paint(el) {
    if (total === null) return;
    el.hidden = total === 0;
    var left = GOAL - total, done = left <= 0;
    el.classList.toggle('is-done', done);
    el.querySelector('.wr-goal__text').innerHTML = done
      ? '<strong>Free shipping unlocked.</strong> It ships on us.'
      : 'You’re <strong>' + money(left) + '</strong> away from free US shipping.';
    var fill = el.querySelector('.wr-goal__fill');
    requestAnimationFrame(function () { fill.style.width = Math.min(100, (total / GOAL) * 100) + '%'; });
  }

  function mount() {
    var spots = [];
    var drawer = document.querySelector('#cart-drawer .cart-drawer__content');
    if (drawer) spots.push([drawer, drawer.querySelector(':scope > .theme-drawer__header')]);
    if (/\/cart\/?$/.test(location.pathname)) {
      var page = document.querySelector('main cart-items-component, main .cart-items-component');
      if (page) spots.push([page.parentNode, page, 'before']);
    }
    spots.forEach(function (s) {
      var host = s[0];
      var el = host.querySelector(':scope > .wr-goal');
      if (!el) {
        el = build();
        var ref = s[1];
        if (ref && ref.parentNode === host) ref[s[2] || 'after'](el); else host.prepend(el);
      }
      paint(el);
    });
  }


  /* "Why this piece?" — an optional line saved to the order as a cart attribute. */
  var WHY_CSS =
    '.wr-why { width: 100%; text-align: left; }' +
    '.wr-why__toggle { all: unset; box-sizing: border-box; cursor: pointer; display: flex; align-items: center; gap: 10px; width: 100%; padding: 4px 0; font-size: 12px; letter-spacing: .14em; text-transform: uppercase; }' +
    '.wr-why__toggle:focus-visible { outline: 2px solid #e0703a; outline-offset: 3px; }' +
    '.wr-why__mark { color: #e0703a; font-size: 15px; line-height: 1; transition: transform .3s ease; }' +
    '.wr-why.is-open .wr-why__mark { transform: rotate(45deg); }' +
    '.wr-why__done { margin-left: auto; font-size: 11px; letter-spacing: .08em; text-transform: none; color: #e0703a; opacity: 0; transition: opacity .3s; }' +
    '.wr-why.has-value .wr-why__done { opacity: 1; }' +
    '.wr-why__body { display: none; padding-top: 10px; }' +
    '.wr-why.is-open .wr-why__body { display: block; }' +
    '.wr-why__hint { margin: 0 0 8px; font-size: 12px; line-height: 1.5; opacity: .7; letter-spacing: 0; text-transform: none; }' +
    '.wr-why__input { box-sizing: border-box; width: 100%; min-height: 64px; resize: vertical; padding: 10px 12px; font: inherit; font-size: 14px; color: inherit; background: rgba(127,127,127,.08); border: 1px solid rgba(127,127,127,.3); border-radius: 0; }' +
    '.wr-why__input:focus { outline: none; border-color: #e0703a; box-shadow: 0 0 0 1px #e0703a, 0 0 14px rgba(224,112,58,.25); }' +
    '.wr-why__count { margin-top: 4px; font-size: 11px; opacity: .5; text-align: right; }' +
    '#cart-drawer .wr-why { padding-bottom: 2px; }' +
    'main .wr-why { margin: 0 0 18px; padding: 14px 0; border-top: 1px solid rgba(127,127,127,.18); border-bottom: 1px solid rgba(127,127,127,.18); }';

  function buildWhy() {
    var el = document.createElement('div');
    el.className = 'wr-why';
    var id = 'wr-why-' + Math.random().toString(36).slice(2, 7);
    el.innerHTML =
      '<button type="button" class="wr-why__toggle" aria-expanded="false" aria-controls="' + id + '">' +
        '<span class="wr-why__mark" aria-hidden="true">+</span><span>Why this piece?</span><span class="wr-why__done">Saved</span>' +
      '</button>' +
      '<div class="wr-why__body" id="' + id + '">' +
        '<p class="wr-why__hint">Optional. What are you wearing it for? A goal, a comeback, someone you love. It rides along with your order.</p>' +
        '<textarea class="wr-why__input" maxlength="140" rows="2" aria-label="Why this piece? (optional)" placeholder="For the first 5am run. For my dad. For the comeback."></textarea>' +
        '<div class="wr-why__count" aria-hidden="true"></div>' +
      '</div>';
    var btn = el.querySelector('.wr-why__toggle');
    var ta = el.querySelector('.wr-why__input');
    btn.addEventListener('click', function () {
      var open = !el.classList.contains('is-open');
      el.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open);
      if (open) ta.focus();
    });
    ta.addEventListener('input', function () {
      why = ta.value;
      paintWhy(el, true);
      clearTimeout(saveT);
      saveT = setTimeout(saveWhy, 700);
    });
    ta.addEventListener('blur', function () { clearTimeout(saveT); saveWhy(); });
    return el;
  }

  var saved = null;
  function saveWhy() {
    if (why === null || why === saved) return;
    var v = why.trim();
    var attrs = {}; attrs[WHY_KEY] = v;
    nativeFetch.call(window, '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function () { saved = why; document.querySelectorAll('.wr-why').forEach(function (e) { paintWhy(e); }); })
      .catch(function () {});
  }

  function paintWhy(el, typing) {
    var ta = el.querySelector('.wr-why__input');
    if (!typing && document.activeElement !== ta && ta.value !== why) ta.value = why || '';
    el.querySelector('.wr-why__count').textContent = (why || '').length + ' / 140';
    el.classList.toggle('has-value', !!(why && why.trim()) && why === saved);
    el.hidden = total === 0;
  }

  function mountWhy() {
    if (why === null) return;
    if (saved === null) saved = why;
    var spots = [];
    var sum = document.querySelector('#cart-drawer .cart-drawer__summary');
    if (sum) spots.push([sum, 'prepend']);
    if (/\/cart\/?$/.test(location.pathname)) {
      var tot = document.querySelector('main .cart-totals');
      if (tot) spots.push([tot, 'before']);
    }
    spots.forEach(function (s) {
      var host = s[1] === 'prepend' ? s[0] : s[0].parentNode;
      var el = host.querySelector(':scope > .wr-why');
      if (!el) {
        el = buildWhy();
        if (why) { el.classList.add('is-open'); el.querySelector('.wr-why__toggle').setAttribute('aria-expanded', 'true'); }
        s[0][s[1]](el);
      }
      paintWhy(el);
    });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.items_subtotal_price; if (why === null) why = (c.attributes && c.attributes[WHY_KEY]) || ''; mount(); mountWhy(); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var st = document.createElement('style');
  st.textContent = CSS + WHY_CSS;
  document.head.appendChild(st);

  document.addEventListener('cart:update', function () { setTimeout(refresh, 150); });
  // The theme updates the cart through fetch; refresh the goal after any cart change.
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refresh, 120); }, function () {});
    } catch (e) {}
    return p;
  };
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () {
      if (total !== null && document.querySelector('#cart-drawer .cart-drawer__content') && !document.querySelector('#cart-drawer .wr-goal')) mount();
      if (why !== null && document.querySelector('#cart-drawer .cart-drawer__summary') && !document.querySelector('#cart-drawer .wr-why')) mountWhy();
    }, 60);
  }).observe(document.documentElement, { subtree: true, childList: true });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
